import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";

import * as forge from "@tylertech/forge";
forge.defineCardComponent();
forge.defineChipComponent();
forge.defineChipSetComponent();
forge.defineCircularProgressComponent();
forge.definePageStateComponent();
import { CoreModule } from "@tylertech/core-module";
import { IncodeModule } from "@tylertech/incode-module";

import * as components from "./components";

import * as pipes from "./pipes";
import { TruncateTextService } from "./services/truncate.text.service";

const angularModules = [
    CommonModule,
    FlexLayoutModule
];

const lgdModules = [
    CoreModule,
    IncodeModule,
];

const exportedComponents = [
    components.BusyIndicatorComponent,
    components.ChipCollectionComponent,
    components.ErrorPageComponent,
    components.LabeledFieldComponent,
    components.TruncateTextComponent,
    pipes.AbbreviateNumberPipe,
    pipes.FileSizePipe,
    pipes.InitialAlphaPipe,
    pipes.InitialPipe,
    pipes.PercentScalePipe,
];

@NgModule({
    imports: [
        ...angularModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents
    ],
    exports: exportedComponents,
    providers: [TruncateTextService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonComponentsModule { }
